<template>
  <div>
    <el-form
      :model="ruleForm"
      status-icon
      :rules="rules"
      ref="ruleForm"
      label-width="100px"
    >
      <el-form-item label="旧密码" prop="oldPass" :error="error">
        <el-input v-model="ruleForm.oldPass"></el-input>
      </el-form-item>
      <el-form-item label="密码" prop="pass">
        <el-input
          type="text"
          v-model="ruleForm.pass"
          autocomplete="off"
        ></el-input>
      </el-form-item>
      <el-form-item label="确认密码" prop="checkPass">
        <el-input
          type="text"
          v-model="ruleForm.checkPass"
          autocomplete="off"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          @click="submitForm('ruleForm')"
          :loading="submitLoading"
          >提交</el-button
        >
        <el-button @click="resetForm('ruleForm')">重置</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { UpdatePassword } from '@api/sys.login'
import util from '@/libs/util.js'
export default {
  data() {
    var checkOldPass = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入旧密码'))
      } else {
        callback()
      }
    }
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'))
      } else {
        if (this.ruleForm.checkPass !== '') {
          this.$refs.ruleForm.validateField('checkPass')
        }
        callback()
      }
    }
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.ruleForm.pass) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      ruleForm: {
        pass: '',
        checkPass: '',
        oldPass: ''
      },
      rules: {
        pass: [{ validator: validatePass, trigger: 'blur' }],
        checkPass: [{ validator: validatePass2, trigger: 'blur' }],
        oldPass: [{ validator: checkOldPass, trigger: 'blur' }]
      },
      error: '',
      submitLoading: false
    }
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.error = ''
          this.submitLoading = true
          var uuid = util.cookies.get('uuid')
          //util.encode64(this.formLogin.password)
          var oldPass = util.encode64(this.ruleForm.oldPass)
          var pass = util.encode64(this.ruleForm.pass)
          UpdatePassword({
            id: uuid,
            oldPass: oldPass,
            pass: pass
          })
            .then(res => {
              console.log(res)
              if (res.affect_rownum == -1) {
                this.error = '旧密码错误'
              } else if (res.affect_rownum == 1) {
                this.$message({
                  message: '修改密码成功',
                  type: 'success'
                })
                this.$emit('changeDialog')
              } else {
                this.$message.error('修改错误，请稍后再试')
              }
            })
            .catch(error => {
              console.log(error)
            })
            .finally(() => {
              this.submitLoading = false
            })

          console.log('submit!', formName, valid, this.ruleForm, uuid)
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    }
  }
}
</script>

<style></style>

<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/layout/header-aside/components/header-update-password/components/update-form/index.vue"
}
</vue-filename-injector>
